import { HttpParams, HttpRequest,  HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { Changelog } from '../models/changelog.model';
import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';

@Injectable()
export class ChangelogService {
  changelogsChanged = new Subject<Changelog[]>();
  changelogsPageChanged = new Subject<Changelog[]>();
  changelogChanged = new Subject<Changelog>();
  changelogOperation = new Subject<Changelog>();

  onGetLast = new Subject();

  private changelogs: Changelog[] = [];
  private changelogsPage: Changelog[] = [];

  constructor(@Inject(APP_CONFIG) private appConfig, private httpClient: HttpClient) {}

  setChangelogs(changelogs: Changelog[]) {
    this.changelogs = changelogs;
    this.changelogsChanged.next(this.changelogs.slice());
  }

  setChangelogsPage(changelogs: Changelog[]) {
    this.changelogsPage = changelogs;
    this.changelogsPageChanged.next(this.changelogs.slice());
  }

  getChangelogs() {
    return this.changelogs.slice();
  }

  httpGetChangelogs(params: any = {}, columns: string = '', order: string = '') {
    let httpParams = new HttpParams();

    if ( columns ) {
      httpParams = httpParams.append('select', columns);
    }
    if ( order ) {
      httpParams = httpParams.append('order', order);
    }

    for (let p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/changelogs',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Changelog[]) => {
        this.setChangelogs(response);
      }
    );
  }

  httpGetChangelogsPage(params: any = {}, columns: string = '', order: string = '') {
    let httpParams = new HttpParams();

    if ( columns ) {
      httpParams = httpParams.append('select', columns);
    }
    if ( order ) {
      httpParams = httpParams.append('order', order);
    }

    for (let p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/changelogs',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Changelog[]) => {
        this.setChangelogsPage(response);
      }
    );
  }

  httpGetChangelog(id: number) {

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/changelogs/' + id,
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Changelog) => {
        this.changelogChanged.next(response);
      }
    );
  }

  httpPostChangelog(data: Changelog) {
    const req = new HttpRequest(
      'POST',
      this.appConfig.API_ENDPOINT + '/changelogs',
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.changelogOperation.next(response);
      }
    );
  }

  httpPutChangelog(id: number, data: Changelog) {
    const req = new HttpRequest(
      'PUT',
      this.appConfig.API_ENDPOINT + '/changelogs/' + id,
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.changelogOperation.next(response);
      }
    );
  }

  httpDeleteChangelog(id: number) {
    const req = new HttpRequest(
      'DELETE',
      this.appConfig.API_ENDPOINT + '/changelogs/' + id
    );

    return this.httpClient.request<any>(req)
    .subscribe(
      (response: any) => {
        this.httpGetChangelogs();
      }
    );
  }

  httpGetLast(params: any) {
    let httpParams = new HttpParams();

    for (const p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/changelogs/last',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
        (response: any) => {
          if (typeof response.body !== 'undefined' && response.body != null) {
              return response.body;
          }

          return [];
        }
    )
    .subscribe(
      (response: any) => {
        this.onGetLast.next(response);
      },
      (response: any) => {
        this.onGetLast.next(response.error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/changelogs.service.ts